module.exports = __webpack_public_path__ + "static/media/19ESCAP22.fe2b7fbe.jpg";